module.exports = __webpack_public_path__ + "img/members of the yakumo family.4ac28336.png";